import { Injectable } from '@angular/core';
import { noop } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  public log(message?: any, ...optionalParams: any[]):void {
    try {
      this.console.log(message, optionalParams);
    } catch {
    }
  }

  public info(message?: any, ...optionalParams: any[]):void {
    try {
      this.console.info(message, optionalParams);
    } catch {
    }
  }

  public warn(message?: any, ...optionalParams: any[]):void {
    try {
      this.console.warn(message, optionalParams);
    } catch {
    }
  }

  public error(message?: any, ...optionalParams: any[]):void {
    try {
      this.console.error(message, optionalParams);
    } catch {
    }
  }

  private console: {
    log(message?: any, ...optionalParams: any[]): void,
    info(message?: any, ...optionalParams: any[]): void,
    warn(message?: any, ...optionalParams: any[]): void,
    error(message?: any, ...optionalParams: any[]): void
  };

  constructor() {
    if (window && 'console' in window) {
      this.console = window.console;
    } else {
      this.console = {
        log: noop,
        info: noop,
        warn: noop,
        error: noop
      };
    }
  }
}
